export default __webpack_public_path__ + "static/media/SourceSansPro-Italic.265b764b.ttf";